import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NoticeInfoComponent } from 'history/notices-log/notice-info/notice-info.component';
import { NoticesLogComponent } from 'history/notices-log/notices-log.component';
import { NoticeInfoResolver } from './notices-log-resolvers';

const routes: Routes = [
  {
    path: '',
    component: NoticesLogComponent,
    data: { title: 'PAGE_TITLES.notice_log' },
  },
  {
    path: ':noticeId',
    component: NoticeInfoComponent,
    resolve: {
      notice: NoticeInfoResolver,
    },
    data: { title: 'PAGE_TITLES.notice_info' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NoticesLogRoutingModule {}
